"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.photographerCollection = void 0;
const firebase_1 = require("../firebase");
const photographerCollection = () => (0, firebase_1.getAppCompat)().firestore().collection('photographersLookup');
exports.photographerCollection = photographerCollection;
